<template>
  <div class="d-flex align-items-center">
    <b-badge class="mr-1" pill variant="secondary">
      {{ selectedObjects }} selected
    </b-badge>
    <span @click="clearSelected" class="clickable text-red small">
      Clear selected
    </span>
  </div>
</template>

<script>
export default {
  name: "TTableSelectionSummary",
  props: {
    selectedObjects: {
      type: Number,
      required: true,
    },
    clear: {
      type: Function,
      required: true,
    },
  },
  methods: {
    clearSelected () {
      this.$emit("clear")
    },
  },
}
</script>

<style lang="scss" scoped>
.badge {
  font-size: 75% !important;
}
</style>
